var VideoService = (function () {
    function videoSrcChange() {
        window.onload = function () {
            $('.videos-slider__item').each(function () {
                $(this).click(function () {
                    var newSrc = $(this).find('iframe').attr('src');
                    $('.videos-main').find('iframe').attr('src', newSrc);
                });

            });
        }

    }
    function videoSlider () {
        $('.videos-slider').slick({
            rows: 2,
            fade: true,
            arrows: true,
            slidesPerRow: 4,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesPerRow: 3,
                        arrows: true
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesPerRow: 2,
                        arrows: true
                    }
                }
            ]
        });
    }
    videoSrcChange();
    videoSlider();
})();